import { DataLayer } from '@grandvisionhq/analytics';

const variantClickEvent = (event_type, product)=>({
        event_type,
        event: 'gvProductClick',
        event_category: product.type,
        click_type: 'variation click',
        product
    })
;
const pushEvent = (event)=>DataLayer.pushEvent(event)
;
const ProductAnalyticsEvents = {
    pushPdpVariantClickEvent: (product)=>{
        const pdpVariantClickEvent = variantClickEvent('pdp', product);
        pushEvent(pdpVariantClickEvent);
    },
    pushPlpVariantClickEvent: (product)=>{
        const plpVariantClickEvent = variantClickEvent('plp', product);
        pushEvent(plpVariantClickEvent);
    }
};

export { ProductAnalyticsEvents };
//# sourceMappingURL=ProductAnalyticsEvents.js.map
